import { Button } from '@/atoms/Button'
import { ArrowRightIcon } from '@/atoms/Icons/ArrowRightIcon'
import { CircleCheckIcon } from '@/atoms/Icons/CircleCheckIcon'
import { AsH2, HeadingSM, ParagraphMD } from '@/atoms/Text'
import { ANGEL_STUDIOS_EMAIL_GROUP_ID } from '@/constants/email'
import { useToast } from '@/molecules/Toast'
import { FlowPhase } from '@/types/codegen-federation'
import { useTranslate } from '@/utils/translate/translate-client'
import { EmailCaptureFormInput } from '../SignUpView/EmailCapture/EmailCaptureFormInput/EmailCaptureFormInput'

interface GetUpdatesCtaProps {
  slug: string
  projectType: string
  currentPhase?: FlowPhase | undefined
}

export function GetUpdatesCta(props: GetUpdatesCtaProps) {
  const { t } = useTranslate('theatrical-presales')

  const { showToast } = useToast()

  // TODO: update EmailCaptureFormInput to be more transparent about error possibilities
  function handleSubmit() {
    showToast(t('thankYouForSigningupAngelUpdates', 'Thank you for signing up for Angel updates!'), {
      shouldHideClose: true,
      icon: <CircleCheckIcon />,
    })
  }

  return <GetUpdatesForm onSubmit={handleSubmit} {...props} />
}

interface GetUpdatesFormProps extends GetUpdatesCtaProps {
  onSubmit: () => void
}
function GetUpdatesForm(props: GetUpdatesFormProps) {
  const { t } = useTranslate('theatrical-presales')
  const updatesText = t('signUpNotificationsAngel', 'Sign up to get Notifications from Angel')

  return (
    <div id="signup-cta" className="px-4 py-20 text-center text-white md:py-28">
      <div className="mb-8">
        <HeadingSM id="get-updates-title" as={AsH2} weight="bold" className="mb-2">
          {t('getUpdates', 'Get Updates')}
        </HeadingSM>
        <ParagraphMD>{updatesText}</ParagraphMD>
      </div>
      <EmailCaptureFormInput
        onSubmit={props.onSubmit}
        position="hub-mid-page"
        subscriptionGroupId={ANGEL_STUDIOS_EMAIL_GROUP_ID}
        projectSlug={props.slug}
        placeholder={t('enterEmail', 'Enter Email')}
        formClassName="relative max-w-lg mx-auto"
        inputClassName="rounded-lg w-full p-4 text-core-gray-950"
        formAriaLabel={t('getUpdates', 'Get Updates')}
        customTrackPayload={{ currentPhase: props.currentPhase?.phaseSlugEnum ?? null }}
      >
        <Button
          aria-label={t('submitEmail', 'Submit Email')}
          variant="black"
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded-lg bg-black px-2"
        >
          <ArrowRightIcon color="white" />
        </Button>
      </EmailCaptureFormInput>
    </div>
  )
}
